// DEPRECATED(legacy-tables): legacy table. Use ServerDataGrid instead.
import { Pagination } from '@mui/material';
import React from 'react';

import WindowSizeHOC from '@sophocles/components/WindowSizeHOC';

class PagingSection extends React.Component {
  constructor(props) {
    super(props);
  }

  getPagesForDisplay() {
    const { currentPage, totalPages } = this.props;

    // if less than 8 pages, just show all of them as options
    if (totalPages < 8) {
      return [...Array(totalPages)].map((x, i) => i + 1); // just make an array of page numbers
    }

    // more than 8 pages, so we need to space them out.
    if (currentPage < 5) {
      // do not show early spacer, the first 5 pages must be shown
      return [1, 2, 3, 4, 5, -1, totalPages];
    }
    if (currentPage + 3 >= totalPages) {
      // do not show late spacer, the last 5 pages must be shown
      return [1, -1].concat([4, 3, 2, 1, 0].map(x => totalPages - x));
    }

    // show both spacers
    return [1, -1].concat([-1, 0, 1].map(x => currentPage + x)).concat([-1, totalPages]);
  }

  render() {
    const { currentPage, onPageSelect, totalPages } = this.props;

    return <Pagination page={currentPage} count={totalPages} onChange={(event, value) => onPageSelect(value)} />;
  }
}

export default WindowSizeHOC(PagingSection);
